import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { StencilsModule } from '@vendasta/store';
import { SearchBoxComponent } from '@vendasta/uikit';
import { CdkDetailRowDirective } from '../common/cdk-detail-row.directive';
import { AccountGroupNotificationsComponent } from './account-group-notifications/account-group-notifications.component';
import { AccountGroupNotificationsService } from './account-group-notifications/account-group-notifications.service';
import { NotificationSettingsComponent } from './account-group-notifications/notification-settings/notification-settings.component';
import { LegacyNotificationPreferenceComponent } from './legacy-notification-preference/legacy-notification-preference.component';
import { LegacyNotificationPreferenceService } from './legacy-notification-preference/legacy-notification-preference.service';
import { LegacyNotificationSettingsComponent } from './legacy-notification-preference/notification-settings/legacy-notification-settings.component';
import { MarketNotificationsComponent } from './market-notifications.component';
import { NotificationPreferencesRoutingModule } from './notification-preferences-routing.module';
import { UserNotificationsComponent } from './user-notifications.component';

@NgModule({
  imports: [
    CdkDetailRowDirective,
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatExpansionModule,
    StencilsModule,
    RouterModule,
    TranslateModule,
    MatSelectModule,
    GalaxyPageModule,
    GalaxyTooltipModule,
    GalaxyAlertModule,
    NotificationPreferencesRoutingModule,
    SearchBoxComponent,
  ],
  declarations: [
    UserNotificationsComponent,
    MarketNotificationsComponent,
    LegacyNotificationPreferenceComponent,
    LegacyNotificationSettingsComponent,
    AccountGroupNotificationsComponent,
    NotificationSettingsComponent,
  ],
  providers: [LegacyNotificationPreferenceService, AccountGroupNotificationsService],
  exports: [LegacyNotificationSettingsComponent, LegacyNotificationPreferenceComponent],
})
export class NotificationPreferencesModule {}
